import { SKELETON_KEY, SKELETON_KEY_NUMBER } from './skeletonFactory';

export function skeletonPlan() {
  return {
    id: SKELETON_KEY,
    planType: SKELETON_KEY,
    baseRate: SKELETON_KEY_NUMBER,
    experienceRate: SKELETON_KEY,
    description: SKELETON_KEY
  };
}
